var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 15.3805V17.4167M11.0833 15.3805C10.2227 15.3866 9.37343 15.1837 8.60842 14.7893C7.84342 14.395 7.18552 13.8209 6.69117 13.1164M11.0833 15.3805C11.944 15.3866 12.7932 15.1821 13.5582 14.7877C14.3232 14.3934 14.9811 13.8193 15.4755 13.1148M11.0833 5.20127C12.9153 5.20127 14.5287 6.1006 15.4755 7.46544M6.69117 7.4686C7.18552 6.76407 7.84342 6.18999 8.60842 5.79564C9.37343 5.40128 10.2227 5.19841 11.0833 5.20444V3.16669M6.69117 7.4686L4.75 6.22252M6.69117 7.4686C6.11428 8.29699 5.80503 9.28222 5.80503 10.2917C5.80503 11.3012 6.11428 12.2864 6.69117 13.1148M17.4167 6.22094L15.4755 7.4686C16.0524 8.29699 16.3616 9.28064 16.3616 10.2901C16.3616 11.2996 16.0524 12.2848 15.4755 13.1132L17.4167 14.3609M4.75 14.3609L6.69117 13.1132",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.584 3.16669H21.0162C26.1779 3.16669 28.7619 3.16669 30.5542 4.43019C31.0672 4.79119 31.5232 5.22185 31.908 5.70477C33.2507 7.3926 33.2506 9.82144 33.2506 14.6823V18.7119C33.2506 23.4033 33.2506 25.7498 32.5081 27.6229C31.3142 30.6359 28.7904 33.0109 25.5889 34.1351C23.5986 34.8334 21.1081 34.8334 16.1206 34.8334C13.2737 34.8334 11.8487 34.8334 10.7119 34.4344C8.88315 33.7915 7.44073 32.4346 6.75832 30.7135C6.33398 29.6432 6.33398 28.3021 6.33398 25.6215V20.5834",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2493 19C33.2493 20.3996 32.6934 21.7419 31.7037 22.7316C30.714 23.7213 29.3717 24.2773 27.9721 24.2773C26.9176 24.2773 25.6747 24.0936 24.6503 24.3675C24.2028 24.4878 23.7949 24.7236 23.4673 25.0512C23.1396 25.3789 22.9038 25.7868 22.7835 26.2343C22.5096 27.2587 22.6933 28.5016 22.6933 29.5561C22.6933 30.2491 22.5568 30.9353 22.2916 31.5756C22.0264 32.2159 21.6376 32.7976 21.1476 33.2877C20.6576 33.7777 20.0758 34.1664 19.4355 34.4316C18.7953 34.6968 18.109 34.8333 17.416 34.8333",
    stroke: "#1F1F1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature_3.1d1056a980e3e2cc00327730c144ad16.svg";
export { ForwardRef as ReactComponent };